import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import PageContainer from "../../components/PageContainer";
import {
  getSupportListServiceVersion2 as getSupportListService,
  getSupportTicketService,
} from "./support.api";
import BottomSheet from "../../components/BottomSheet";
import RateToConversion from "../chat/RateToConversion";
import ChatHolder from "../chat/message/ChatHolder";
import Footer from "../chat/footer/Footer";
import { message } from "antd";
import { SessionStatus } from "../../constant/Types";
import { ChatLoadingContext } from "../chat/ChatLoadingContextProvider";
import { InReplyContext } from "../chat/Chat";

const SupportChat = () => {
  const { id } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [lawyerRateForm, setLawyerRateForm] = useState(false);
  const [scrollBtnView] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [ticketDetail, setTicketDetail] = useState({
    state: {
      current: { state: SessionStatus.OPEN },
    },
    rateDto: null,
  });
  const [totalElements, setTotalElements] = useState(0);
  const { AllChatLoading, setAllChatLoading } = useContext(ChatLoadingContext);
  const [inReply, setInReply] = useState();

  const chatElement = useRef(null);

  function getMessagesList() {
    setLoading(true);
    getSupportListService(id)
      .then((r) => {
        const messages = r.data.content.map((cont) => {
          const newcont = cont;

          // eslint-disable-next-line no-useless-escape
          if (cont.content === `\"\"`) {
            newcont.content = null;
          }

          return newcont;
        });

        // setMessageList(r.data.content);
        setMessageList(messages);
        if (r.data.totalElements) {
          setTotalElements(r.data.totalElements);
        }
      })
      .catch((e) => {
        message.error("خطا در دریافت پیام ها");
      })
      .finally(() => {
        setAllChatLoading(false);
        setLoading(false);
      });
  }

  function getSupportTicket() {
    getSupportTicketService(id)
      .then((resp) => {
        setTicketDetail(resp.data);
      })
      .catch((error) => message.error("خطایی در دریافت اطلاعات"));
  }

  useEffect(() => {
    getMessagesList();
    getSupportTicket();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // if (chatElement && chatElement.current) {
    //   chatElement.current.addEventListener("scroll", handleScroll);
    // }
    // return function cleanup() {
    //   if (chatElement && chatElement.current) {
    //     // eslint-disable-next-line
    //     chatElement.current.removeEventListener("scroll", handleScroll);
    //   }
    // };
    // eslint-disable-next-line
  }, []);

  function handleLoadMore() {
    setPageNumber(pageNumber + 1);
  }

  const scrollToBottom = () => {
    if (chatElement && chatElement.current) {
      chatElement.current.scrollTop = chatElement.current.scrollHeight;
    }
  };

  // function handleScroll(e) {
  // let scrollTop = e.target.scrollTop;
  // let scrollHeight = e.target.scrollHeight;
  // let height = e.target.offsetHeight;
  // let res = scrollHeight - (scrollTop + height);

  // setScrollBtnView(res > 70);

  // if (scrollTop < 10) {
  //   handleLoadMore();
  // }
  // }

  function toggleRateForm() {
    setLawyerRateForm(!lawyerRateForm);
  }

  return (
    <>
      <PageContainer
        classNames={"chat-page no-padding"}
        headerProps={{
          link: "/support",
          content: "پشتیبانی",
          className: "pos-fix chat-header",
        }}
        loading={loading || AllChatLoading}
      >
        <InReplyContext.Provider value={{inReply, setInReply}}>
        <ChatHolder
          messagesList={messageList}
          isTicket={true}
          isTicketClose={
            ticketDetail.state.current.state === SessionStatus.CLOSED
          }
          allowRate={!ticketDetail.rateDto || ticketDetail.rateDto === null}
          hasMore={false}
          handleLoadMore={handleLoadMore}
          chatElement={chatElement}
          scrollBtnView={scrollBtnView}
          totalElements={totalElements}
          openRateForm={toggleRateForm}
        />

        <Footer
          isTicket={true}
          ticketId={id}
          isBaseOnTime={false}
          getMessages={getMessagesList}
          sessionDetail={{ sessionStatus: SessionStatus.OPEN }}
          ticketDetail={ticketDetail}
          scrollToBottom={scrollToBottom}
        />
        </InReplyContext.Provider>
      </PageContainer>
      <BottomSheet
        setClose={toggleRateForm}
        isOpen={lawyerRateForm}
        classNames={"lawyer-rate-holder"}
      >
        <RateToConversion
          closeBottomSheet={toggleRateForm}
          isTicket
          userInfo={{
            avatarImage: "ADMIN",
            name: "",
            description: "",
          }}
        />
      </BottomSheet>
    </>
  );
};

export default SupportChat;
